import { 
    REGISTER_LICENSE_CODE_VALIDATE_SUCCESS,
    REGISTER_LICENSE_CODE_CLEAR_ERROR, 
    REGISTER_LICENSE_CODE_CLEAR_STEP,
    REGISTER_LICENSE_CODE_RESET,
    REGISTER_LICENSE_CODE_ERROR
} from "../constants";
import { error as errorReducer } from './Error.reducer';

export const registerLicenseCode = (state = {}, action) => {
    switch (action.type) {
        case REGISTER_LICENSE_CODE_VALIDATE_SUCCESS:
            return {
                step: 'validationSuccess',
                payload: {
                    ...state.payload,
                    ...action.payload,
                }
            };
        case REGISTER_LICENSE_CODE_ERROR:
            return {
                step: Object.hasOwn(action?.payload?.error, "modal") ? "modalError" : "",
                payload: {
                    ...state.payload,
                },
                errors: errorReducer(state.errors, action)
            };
        case REGISTER_LICENSE_CODE_CLEAR_ERROR:
            return {
                ...state,
                ...action.payload
            }
        case REGISTER_LICENSE_CODE_RESET:
            return {
                step: '',
                payload: {
                    ...state.payload,
                    productImageUrl: undefined,
                    productName: undefined,
                },
                errors: [],
            }
        default:
            return state;
    }
};
